import React from 'react';
import { Globe, DollarSign, BarChart3, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SectionTitle, InsightBox, MR, JB } from './DemoShared';

const ICON_MAP = { international: Globe, sponsorship: DollarSign, digital: BarChart3 };
const CATS = ['international', 'sponsorship', 'digital'];

export function HiddenRevenue({ club, dt, onExplorePilot }) {
  const rv = dt.revenue;
  const { revenue, estRevenue } = club;
  const pctLow = Math.round((revenue.total.low / estRevenue) * 100);
  const pctHigh = Math.round((revenue.total.high / estRevenue) * 100);

  return (
    <section data-testid="section-revenue">
      <SectionTitle
        label={rv.eyebrow}
        title={rv.title}
        subtitle={rv.subtitle}
      />

      <div className="rounded-xl border border-[hsl(150,50%,45%)]/20 bg-[hsl(150,50%,45%)]/[0.04] p-6 mb-4" data-testid="revenue-total">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <p className="text-xs text-muted-foreground/60 uppercase tracking-wider mb-2" style={JB}>{rv.opportunityRange}</p>
            <div className="flex items-baseline gap-1">
              <span className="text-3xl font-bold text-[hsl(150,50%,45%)]" style={MR}>&euro;{revenue.total.low}M&ndash;{revenue.total.high}M</span>
              <span className="text-sm text-muted-foreground ml-1">{rv.perYear}</span>
            </div>
          </div>
          <div className="sm:text-right">
            <p className="text-xs text-muted-foreground/60 uppercase tracking-wider mb-1" style={JB}>{rv.ofRevenue}</p>
            <span className="text-2xl font-bold text-[hsl(150,50%,45%)]" style={MR}>{pctLow}&ndash;{pctHigh}%</span>
            <p className="text-[11px] text-muted-foreground/40">{rv.uplift}</p>
          </div>
        </div>
      </div>

      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        {CATS.map((key) => {
          const r = revenue[key];
          const Icon = ICON_MAP[key];
          return (
            <div key={key} className="rounded-xl border border-border/30 bg-card/40 p-5" data-testid={`revenue-${key}`}>
              <div className="flex items-center gap-2 mb-3">
                <Icon className="w-4 h-4 text-primary/70" />
                <span className="text-[10px] text-muted-foreground/60 uppercase tracking-wider" style={JB}>{r.label}</span>
              </div>
              <div className="flex items-baseline gap-1 mb-3">
                <span className="text-2xl font-bold text-foreground" style={MR}>&euro;{r.low}&ndash;{r.high}M</span>
              </div>
              <p className="text-xs text-muted-foreground leading-relaxed">{r.why}</p>
            </div>
          );
        })}
      </div>

      <InsightBox variant="positive">
        {club.revenueInsight}
      </InsightBox>

      <div className="mt-6 text-center">
        <Button variant="outline" onClick={onExplorePilot} className="rounded-lg border-primary/30 text-primary hover:bg-primary/10 gap-2" data-testid="revenue-cta-pilot">
          {rv.ctaPilot} <ArrowRight className="w-3.5 h-3.5" />
        </Button>
      </div>
    </section>
  );
}
